@if ((country === 'BRA' && productCode === 'PREB') ||
(country === 'BRA' && productCode !== 'PREB') ||
country === 'CHL' || country === 'COL') {
<div>
  @if (isContractCreated === true) {
  <div class="contract-summary">
    <div class="contract-created-card">
      <div class="contract-created-content">
        <h1>{{'TRANSLATE.CONGRATULATIONS' | translate }}</h1>
        <h3>{{'TRANSLATE.YOU.HAVE.JUST.PURCHASED.FORD.PROTECT' | translate }} <br />
          {{'TRANSLATE.NEXT.YOU.CAN.ACCESS.CONTRACT.TEXT' | translate }} <br />
          {{'TRANSLATE.THANK.YOU.AND.COUNT.ON.US' | translate }}</h3>
      </div>
      <div class="col-12 md:col-12 lg:col-12 button-position-download contract-created-action">
        <button id="btnDownload" class="btn-download contract-created-download" type="button"
          [disabled]="isDownloadingContract" [ngClass]="{ 'is-loading': isDownloadingContract }"
          [attr.aria-busy]="isDownloadingContract" (click)="downloadPDF()">
          @if (!isDownloadingContract) {
          <i class="pi pi-download" aria-hidden="true"></i>
          }
          @if (isDownloadingContract) {
          <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
          }
          <span class="btn-download-label">
            {{ (isDownloadingContract ? 'TRANSLATE.DOWNLOADING.TERMS.OF.AGREEMENT' :
            'TRANSLATE.DOWNLOAD.TERMS.OF.AGREEMENT') | translate }}
          </span>
        </button>
      </div>
    </div>
  </div>
  }
  @if (isContractActive === true) {
  <div class="contract-summary">
    <div class="grid">
      <div class="col-12">
        <span class="title">{{'TRANSLATE.SALES.CHANNEL' | translate }}</span>
      </div>
    </div>
    <div class="contract-created-card">
      <div class="contract-created-content">
        <h1>{{'TRANSLATE.HELLO' | translate }}</h1>
        <h3>{{'TRANSLATE.THE.CONTRACT.HAS.BEEN.SIGNED.AND.IS.ACTIVE' | translate }} <br />
          {{'TRANSLATE.DOWNLOAD.CONTRACT' | translate }} <br /></h3>
      </div>
      <div class="col-12 md:col-12 lg:col-12 button-position-download contract-created-action">
        <button id="btnDownload" class="btn-download contract-created-download" type="button"
          [disabled]="isDownloadingContract" [ngClass]="{ 'is-loading': isDownloadingContract }"
          [attr.aria-busy]="isDownloadingContract" (click)="downloadPDF()">
          @if (!isDownloadingContract) {
          <i class="pi pi-download" aria-hidden="true"></i>
          }
          @if (isDownloadingContract) {
          <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
          }
          <span class="btn-download-label">
            {{ (isDownloadingContract ? 'TRANSLATE.DOWNLOADING.TERMS.OF.AGREEMENT' :
            'TRANSLATE.DOWNLOAD.TERMS.OF.AGREEMENT') | translate }}
          </span>
        </button>
      </div>
    </div>
  </div>
  }
  @if (isContractCreated === false && isContractActive === false) {
  <div class="contract-signature-summary">
    <form [formGroup]="contractSignatureForm">
      <div class="legal-main-card">
        <table id="pdfPaymentMethod" #pdfPaymentMethod style="width:100%; height:100% ">
          <tr>
            <td align="justify" width="100%">
              <div class="col-10 col-offset-1">
                <div class="p-fluid">
                  @if ( country === 'BRA' && productCode === 'PREB' ) {
                  <div>
                    <app-legal-text-contract-bra-preb></app-legal-text-contract-bra-preb>
                  </div>
                  }
                  @if (country === 'BRA' && productCode !== 'PREB') {
                  <div>
                    <app-legal-text-contract-bra-bas1></app-legal-text-contract-bra-bas1>
                  </div>
                  }
                  @if ( country === 'CHL') {
                  <div>
                    <app-legal-text-contract-chile></app-legal-text-contract-chile>
                  </div>
                  }
                  @if ( country === 'COL') {
                  <div>
                    <div class="field-checkbox p-col">
                      <app-legal-text-contract-colombia></app-legal-text-contract-colombia>
                    </div>
                  </div>
                  }
                  <div class="signature-consent-section">
                    <div class="consent-card">
                      <div class="consent-check" #termsConsent [class.terms-focus-active]="termsFocusActive">
                        <p-checkbox id="termsUser" binary="true" [(ngModel)]="termsUser" formControlName="termsUser"
                          required (onChange)="onTermsChange()"></p-checkbox>
                        <label for="termsUser" class="consent-label">
                          <b>{{'TRANSLATE.DECLARE.THAT.HAVE.READ.AGREE.CONDITIONS' | translate }}</b>
                        </label>
                      </div>
                      @if (submitted && f.termsUser.errors) {
                      <p-message class="client-data-message" severity="error"
                        text="{{ 'TRANSLATE.REQUIRED.FIELD' | translate }}">
                      </p-message>
                      }
                    </div>
                    <div class="signature-meta-card">
                      <span class="signature-meta-label">{{'TRANSLATE.PLACE.DATE' | translate }}</span>
                      <span class="signature-meta-value">São Paulo, {{ getDay() }} de {{ getMonth() }} de {{ getYear()
                        }}</span>
                    </div>
                    <div class="signature-panel">
                      <div class="signature-panel-header">
                        <span class="signature-panel-title">{{'TRANSLATE.TWO.POINTS.INSURED.SIGNATURE' | translate
                          }}</span>
                      </div>
                      <div class="signature-box-container signature-canvas-shell" #signatureShell
                        [class.is-drawing]="isDrawing" [class.has-error]="submitted && f.signature?.errors">
                        <app-signature-pad #signaturePad formControlName="signature" (changed)="drawComplete()"
                          (drawing)="isDrawing = $event"></app-signature-pad>
                      </div>
                      @if (submitted && f.signature?.errors) {
                      <p-message class="client-data-message" severity="error"
                        text="{{ 'TRANSLATE.REQUIRED.FIELD' | translate }}">
                      </p-message>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
        <table #pdfPaymentMethod style="width:100%; height:100% ">
          <tr>
            <td align="justify" width="100%">
              <div class="col-12 md:col-12 lg:col-12 button-position">
                <button id="btnClear" class="undo-action-button app-clean-button" type="button" (click)="drawClean()"
                  [disabled]="isSubmitted">
                  <i class="pi pi-trash" aria-hidden="true"></i>
                  <span class="undo-action-button-label">
                    {{ 'TRANSLATE.CLEAR.SIGNATURE' | translate }}
                  </span>
                </button>
                <app-cta-button [label]="'TRANSLATE.FINALIZE'" [loadingLabel]="'TRANSLATE.FINISHING'" icon="pi-check"
                  [loading]="isSubmitted" [successState]="isCtaSuccess" (buttonClick)="buttonSave()">
                </app-cta-button>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </form>
  </div>
  }
</div>
}


@if (errorContract) {
<div>
  <div class="client-data-field-text contract-error-message">
    {{ 'TRANSLATE.COULD.NOT.FIND.YOUR.CONTRACT' | translate }}
  </div>
</div>
}